import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TaxIdIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C11.448 2 11 2.448 11 3V4H13V3C13 2.448 12.552 2 12 2ZM13 4V5C13 5.552 12.552 6 12 6C11.448 6 11 5.552 11 5V4H3C1.895 4 1 4.895 1 6V18C1 19.105 1.895 20 3 20H21C22.105 20 23 19.105 23 18V6C23 4.895 22.105 4 21 4H13ZM8 8C9.133 8 10 8.867 10 10C10 11.133 9.133 12 8 12C6.867 12 6 11.133 6 10C6 8.867 6.867 8 8 8ZM15 9H19C19.552 9 20 9.448 20 10C20 10.552 19.552 11 19 11H15C14.448 11 14 10.552 14 10C14 9.448 14.448 9 15 9ZM8 13C10.185 13 12 13.9088 12 15.2168V15.5C12 15.776 11.776 16 11.5 16H4.5C4.224 16 4 15.776 4 15.5V15.2168C4 13.9088 5.815 13 8 13ZM15 13H19C19.552 13 20 13.448 20 14C20 14.552 19.552 15 19 15H15C14.448 15 14 14.552 14 14C14 13.448 14.448 13 15 13Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

TaxIdIcon.propTypes = {
  sx: PropTypes.object,
};

export default TaxIdIcon;
